// Simple storage implementation using localStorage as fallback
// This provides the same interface as the expected window.storage API

class SimpleStorage {
  constructor() {
    this.storage = window.localStorage;
  }

  async get(key) {
    try {
      const value = this.storage.getItem(key);
      return { value };
    } catch (error) {
      console.error('Storage get error:', error);
      return { value: null };
    }
  }

  async set(key, value) {
    try {
      this.storage.setItem(key, value);
      return true;
    } catch (error) {
      console.error('Storage set error:', error);
      return false;
    }
  }

  async delete(key) {
    try {
      this.storage.removeItem(key);
      return true;
    } catch (error) {
      console.error('Storage delete error:', error);
      return false;
    }
  }
}

// Initialize storage if it doesn't exist
if (!window.storage) {
  window.storage = new SimpleStorage();
  console.log('SimpleStorage initialized');
}

export default SimpleStorage;
